import curd from '../curd'

const BASE_PATH = '/site/device/factor-status'

export default curd(BASE_PATH, {
  changeIsAlarm: (id, isAlarm) => ({
    url: `${BASE_PATH}/alarm/${id}/${isAlarm}`,
    method: 'PUT'
  }),
  getFactorsBySiteDeviceId: siteDeviceId => ({
    url: `${BASE_PATH}/unselected/${siteDeviceId}`,
    method: 'GET'
  }),
  batchSave: data => ({
    url: `${BASE_PATH}/save/list`,
    method: 'POST',
    data
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/SiteDeviceStatus.js